import React from 'react';
import { SearchIcon, MessageSquareIcon, FileTextIcon, DatabaseIcon, ScaleIcon, ChevronLeftIcon } from 'lucide-react';
interface SidebarProps {
  activePage: 'discovery' | 'ask' | 'deposition';
  setActivePage: (page: 'discovery' | 'ask' | 'deposition') => void;
  onBackToCases: () => void;
}
export function Sidebar({
  activePage,
  setActivePage,
  onBackToCases
}: SidebarProps) {
  const navItems = [{
    id: 'discovery',
    label: 'Discovery',
    icon: SearchIcon
  }, {
    id: 'ask',
    label: 'Ask',
    icon: MessageSquareIcon
  }, {
    id: 'deposition',
    label: 'Deposition',
    icon: FileTextIcon
  }] as const;
  return <div className="w-[220px] bg-[#0A1520] border-r border-navy-border flex flex-col h-screen flex-shrink-0" data-id="element-186">
      <button onClick={onBackToCases} className="p-4 border-b border-navy-border flex items-center gap-2 hover:bg-navy-surface transition-colors w-full text-left" title="Back to all cases" data-id="element-187">
        <div className="bg-accent-amber text-navy p-1 rounded-sm" data-id="element-188">
          <ScaleIcon size={18} className="stroke-[2.5]" data-id="element-189" />
        </div>
        <span className="font-bold text-lg tracking-tight text-white" data-id="element-190">
          Geniac
        </span>
      </button>

      <div className="px-3 pt-3 pb-2 border-b border-navy-border" data-id="element-191">
        <button onClick={onBackToCases} className="flex items-center gap-1.5 text-xxs text-text-muted hover:text-accent-amber transition-colors mb-2 group" data-id="element-192">
          <ChevronLeftIcon size={12} className="group-hover:-translate-x-0.5 transition-transform" data-id="element-193" />
          All Cases
        </button>
        <div className="text-xs font-medium text-text-secondary leading-snug px-0.5" data-id="element-194">
          Meridian Properties v. Blackstone Dev., et al.
        </div>
      </div>

      <div className="px-3 py-4 flex-1 flex flex-col gap-1" data-id="element-195">
        <div className="text-xxs font-semibold text-text-muted uppercase tracking-wider mb-2 px-2" data-id="element-196">
          Workbench
        </div>

        {navItems.map(item => {
        const Icon = item.icon;
        const isActive = activePage === item.id;
        return <button key={item.id} onClick={() => setActivePage(item.id)} className={`flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium transition-colors text-left w-full
                ${isActive ? 'bg-navy-surface text-white border-l-2 border-accent-amber pl-[10px]' : 'text-text-secondary hover:bg-navy-surface hover:text-white border-l-2 border-transparent pl-[10px]'}`} data-id="element-197">
              <Icon size={16} className={isActive ? 'text-accent-amber' : 'text-text-muted'} data-id="element-198" />
              {item.label}
            </button>;
      })}
      </div>

      <div className="p-3 border-t border-navy-border" data-id="element-199">
        <button className="flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium text-text-muted hover:text-text-secondary hover:bg-navy-surface transition-colors w-full text-left" data-id="element-200">
          <DatabaseIcon size={16} data-id="element-201" />
          Sources
        </button>
      </div>
    </div>;
}